<template>
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-md shadow-lg p-5 w-[28rem]">
      <h3 class="text-base font-semibold mb-3">Mark as Client Paid</h3>

      <div class="text-xs text-gray-600 mb-3">
        {{ recordIds.length }} record<span v-if="recordIds.length !== 1">s</span> selected, total ${{ formatAmount(totalAmount) }}.
      </div>

      <label class="block text-sm mb-1">Date payment received</label>
      <input
        v-model="paidOn"
        type="date"
        class="w-full p-2 border border-gray-400 rounded-md mb-3"
      />

      <div v-if="errorSummary" class="mb-3 p-2 rounded bg-red-50 border border-red-200 text-sm text-red-700 whitespace-pre-wrap">
        {{ errorSummary }}
      </div>

      <div class="flex justify-end gap-2">
        <button
          class="text-sm px-3 py-1.5 border border-gray-400 rounded hover:bg-gray-100"
          @click="$emit('close')"
        >Cancel</button>
        <button
          class="text-sm px-3 py-1.5 rounded bg-accent-primary text-white hover:bg-accent-secondary disabled:opacity-50"
          :disabled="!paidOn || applying"
          @click="apply"
        >{{ applying ? 'Applying...' : 'Mark Paid' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: "mark-paid-modal" };
</script>

<script setup>
import { ref, computed, defineProps, defineEmits } from "vue";
import { useStore } from "vuex";
import { useToast } from "vue-toast-notification";
import { bulkMarkClientPaid } from "@/services/Expense.js";

const props = defineProps({
  recordIds: { type: Array, required: true },
  records: { type: Array, required: true },
});
const emit = defineEmits(["close", "applied"]);

const store = useStore();
const $toast = useToast();

const paidOn = ref(todayISO());
const applying = ref(false);
const errorSummary = ref("");

function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function formatAmount(n) {
  if (n === null || n === undefined) return "0.00";
  const num = typeof n === "string" ? parseFloat(n) : n;
  return num.toFixed(2);
}

const totalAmount = computed(() =>
  props.records.reduce((sum, r) => sum + (parseFloat(r.amount) || 0), 0)
);

async function apply() {
  if (!paidOn.value) return;
  applying.value = true;
  errorSummary.value = "";
  const token = store.state.auth.token;
  try {
    const result = await bulkMarkClientPaid(token, props.recordIds, paidOn.value);
    if (result.errors && result.errors.length > 0) {
      errorSummary.value = `Applied ${result.applied_ids.length}, failed ${result.errors.length}:\n`
        + result.errors.map((e) => `#${e.id}: ${e.detail}`).join('\n');
    } else {
      $toast.open({ message: `Marked ${result.applied_ids.length} as paid`, type: 'success', duration: 2000 });
      emit("applied", result);
    }
  } catch (error) {
    const detail = error.response && error.response.data && JSON.stringify(error.response.data);
    errorSummary.value = detail || (error.message || 'Failed');
  }
  applying.value = false;
}
</script>
